import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
import router from '@/router'
import i18n from '../../internatinalization/i18n'
const gemnoteAPI = api()

import {
  LOAD_USER_PROFILE,
  SET_USER_PROFILE,
  RESET_PROFILE_STATE,
  UPDATING_USER_PROFILE,
  SET_IDP_PROFILE,
  SET_EXISTING_IDP_PROFILE,
  UPDATING_IPD_SETTING
} from '@/state/mutationTypes'

const defaultIdpSettings = {
  serviceUrl: `${process.env.VUE_APP_GEMNOTE_API_URL}saml/auth`,
  assertionUrl: `${process.env.VUE_APP_IDP_ACS_BINDING}`,
  nameIdentifierFormat: `${process.env.VUE_APP_IDP_NAME_ID_FORMAT}`
}

export default {
  async getProfile({ commit, dispatch }, { reloadProfile }) {
    commit(LOAD_USER_PROFILE, status.LOADING)
    try {
      const response = await gemnoteAPI.get('user')
      const data = getData(response)

      let user = {
        id: data.id,
        name: data.attributes.name,
        fullName:
          data.attributes.fullName !== '' ? data.attributes.fullName : '',
        firstName:
          data.attributes.firstName !== '' ? data.attributes.firstName : '',
        lastName:
          data.attributes.lastName !== '' ? data.attributes.lastName : '',
        email: data.attributes.email,
        availableBudgetAmount: data.attributes.availableBudgetAmount
          ? parseFloat(data.attributes.availableBudgetAmount).toFixed(2)
          : 0,
        infiniteTeamUserBudget: data.attributes.infiniteTeamUserBudget
          ? data.attributes.infiniteTeamUserBudget
          : false,
        emailNotificationPreferences: data.attributes
          .emailNotificationsPreferencesBlob
          ? data.attributes.emailNotificationsPreferencesBlob
          : {}
      }

      // this code is for letting know what role user have on platform
      if (data.attributes.roles.length > 0) {
        user.roles = data.attributes.roles
      } else {
        user.roles = ['member']
      }

      commit(SET_USER_PROFILE, user)
      commit(LOAD_USER_PROFILE, status.LOADED)
      if (reloadProfile) {
        router.go()
      }
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateUserProfile({ commit, dispatch, state }, { hideNotification }) {
    commit(UPDATING_USER_PROFILE, hideNotification ? false : true)
    let { user: userObject } = state
    try {
      const response = await gemnoteAPI.put('user', {
        user: {
          first_name: userObject.firstName,
          last_name: userObject.lastName,
          email_notifications_preferences_blob: {
            send_order_confirmation_email:
              userObject.emailNotificationPreferences
                .sendOrderConfirmationEmail,
            send_shipping_confirmation_email:
              userObject.emailNotificationPreferences
                .sendShippingConfirmationEmail,
            send_group_order_summary_email:
              userObject.emailNotificationPreferences
                .sendGroupOrderSummaryEmail,
            send_e_commerce_order_confirmation_email:
              userObject.emailNotificationPreferences
                .sendECommerceOrderConfirmationEmail
          }
        }
      })

      const data = getData(response)

      let user = {
        id: data.id,
        name: data.attributes.name,
        fullName: data.attributes.fullName,
        firstName: data.attributes.firstName,
        lastName: data.attributes.lastName,
        email: data.attributes.email,
        availableBudgetAmount: data.attributes.availableBudgetAmount
          ? parseFloat(data.attributes.availableBudgetAmount).toFixed(2)
          : 0,
        infiniteTeamUserBudget: data.attributes.infiniteTeamUserBudget
          ? data.attributes.infiniteTeamUserBudget
          : false,
        emailNotificationPreferences: data.attributes
          .emailNotificationsPreferencesBlob
          ? data.attributes.emailNotificationsPreferencesBlob
          : {}
      }

      // this code is for letting know what role user have on platform
      if (data.attributes.roles.length > 0) {
        user.roles = data.attributes.roles
      } else {
        user.roles = ['member']
      }

      commit(SET_USER_PROFILE, user)
      commit(UPDATING_USER_PROFILE, false)

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('profile.action.update-profile-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      commit(UPDATING_USER_PROFILE, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.update-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  // IDP PROFILE
  async getIDPSettings({ commit, dispatch }) {
    commit(LOAD_USER_PROFILE, status.LOADING)
    try {
      const response = await gemnoteAPI.get('team/idp_setup')
      const data = getData(response)

      if (data && data.attributes) {
        commit(SET_IDP_PROFILE, {
          ...data.attributes,
          ...defaultIdpSettings
        })
        commit(SET_EXISTING_IDP_PROFILE, true)
      } else {
        commit(SET_IDP_PROFILE, {
          ...defaultIdpSettings
        })
        commit(SET_EXISTING_IDP_PROFILE, false)
      }

      commit(LOAD_USER_PROFILE, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async createIDPSetup({ commit, dispatch }, payload) {
    const idpSettings = {
      idp_entity_id: payload.idpEntityId,
      authn_context: payload.authnContext,
      idp_slo_target_url: payload.idpSloTargetUrl,
      idp_sso_target_url: payload.idpSsoTargetUrl,
      idp_cert_fingerprint: payload.idpCertFingerprint,
      idp_cert_fingerprint_algorithm: payload.idpCertFingerprintAlgorithm
    }

    try {
      const response = await gemnoteAPI.post('team/idp_setup', idpSettings)
      const data = getData(response)
      if (data && data.attributes) {
        commit(SET_IDP_PROFILE, {
          ...data.attributes,
          ...defaultIdpSettings
        })

        commit(SET_EXISTING_IDP_PROFILE, true)
      } else {
        commit(SET_EXISTING_IDP_PROFILE, false)
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('profile.action.create-idp-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async updateIDPSetup({ commit, dispatch }, payload) {
    const idpSettings = {
      idp_entity_id: payload.idpEntityId,
      authn_context: payload.authnContext,
      idp_slo_target_url: payload.idpSloTargetUrl,
      idp_sso_target_url: payload.idpSsoTargetUrl,
      idp_cert_fingerprint: payload.idpCertFingerprint,
      idp_cert_fingerprint_algorithm: payload.idpCertFingerprintAlgorithm
    }

    try {
      const response = await gemnoteAPI.put('team/idp_setup', idpSettings)
      const data = getData(response)
      if (data && data.attributes) {
        commit(SET_IDP_PROFILE, {
          ...data.attributes,
          ...defaultIdpSettings
        })
        commit(SET_EXISTING_IDP_PROFILE, true)
      } else {
        commit(SET_EXISTING_IDP_PROFILE, false)
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('profile.action.update-idp-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async enableIDPSettings({ commit, dispatch }) {
    commit(UPDATING_IPD_SETTING, true)

    try {
      const response = await gemnoteAPI.post('team/idp_setup/enable_sso')
      const data = getData(response)
      if (data && data.attributes) {
        commit(SET_IDP_PROFILE, {
          ...data.attributes,
          ...defaultIdpSettings
        })
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('profile.action.update-idp-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
    commit(UPDATING_IPD_SETTING, false)
  },
  async disbleIDPSettings({ commit, dispatch }) {
    commit(UPDATING_IPD_SETTING, true)

    try {
      const response = await gemnoteAPI.post('team/idp_setup/disable_sso')
      const data = getData(response)
      if (data && data.attributes) {
        commit(SET_IDP_PROFILE, {
          ...data.attributes,
          ...defaultIdpSettings
        })
      }

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('profile.action.update-idp-success')]
        },
        { root: true }
      )
    } catch (error) {
      console.log(error)
      commit(LOAD_USER_PROFILE, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('profile.action.get-profile-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
    commit(UPDATING_IPD_SETTING, false)
  },
  resetProfileState({ commit }) {
    commit(RESET_PROFILE_STATE)
  }
}
